import styles from './styles.module.scss';

type Size = 'xs' | 'sm' | 'md' | 'lg';

type Props = {
  size?: Size;
  ariaLabel?: string;
};

// viewBox は SVG の座標系定義のためサイズごとに必要。
// スタイル値（width/height/r/stroke-width）は SCSS 側に集約。
const VIEW_BOX: Record<Size, string> = {
  xs: '0 0 16 16',
  sm: '0 0 20 20',
  md: '0 0 24 24',
  lg: '0 0 48 48',
};

export const Spinner: React.FC<Props> = ({ size = 'md', ariaLabel = '読み込み中' }) => {
  return (
    <output aria-label={ariaLabel} className={`${styles.root} ${styles[size]}`}>
      <svg viewBox={VIEW_BOX[size]} fill='none' aria-hidden='true'>
        <circle cx='50%' cy='50%' stroke='currentColor' className={styles.track} />
        <circle
          cx='50%'
          cy='50%'
          stroke='currentColor'
          strokeLinecap='round'
          pathLength='100'
          strokeDasharray='25 75'
          className={styles.arc}
        />
      </svg>
    </output>
  );
};
